import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        layout: null,
        authentication: null,
    },
    mutations: {
        set(state, params) {
            state[params.key] = params.data;
        }
    },
    actions: {
        vuexSetLayout(context, data) {
            context.commit("set", {
                key: "layout",
                data: data
            });
        },
        vuexSetAuthentication(context, data) {
            console.log(data);
            context.commit("set", {
                key: "authentication",
                data: data
            });
        }
    }
})

export default store
